import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetSupportiveMedicationDrugActivities(drugId: string | undefined) {
  return useQuery(queries.drugCatalog.getSupportiveMedicationActivitiesById(drugId || ''))
}
